import React, { useEffect, useState } from 'react';

import { Box, Button, CircularProgress, IconButton, Grid, TextField, Tooltip } from '@material-ui/core';
import { get } from 'lodash';
import { toast } from 'react-toastify';

import AxlDialog from '../AxlDialog';
import { getShipmentHistory, updateDropoffInfo, getAppFeatures } from '../../stores/api';
import { colors } from '../../themes/colors';

const TextFieldCustom = (props) => {
  return <TextField variant="outlined" size="small" fullWidth {...props} />;
};

const LABEL = {
  STREET: 'Address line 1',
  STREET_2: 'Address line 2',
  CITY: 'City',
  STATE: 'State',
  ZIPCODE: 'Zipcode',
};

function DropoffInfoDialog({ isOpen, handleClose, shipment, shipmentStore, correctedInfo }) {
  const [isUpdating, setIsUpdating] = useState(false);
  const [street, setStreet] = useState(get(shipment, 'dropoff_address.street', ''));
  const [street2, setStreet2] = useState(get(shipment, 'dropoff_address.street2', ''));
  const allowEditAddress1 = get(shipment, 'extra.allow_editing_delivery_address', false);
  const clientID = get(shipment, 'client_id', null);
  const regionCode = get(shipment, 'region_code', null);
  const [isFetching, setIsFetching] = useState(false);
  const [enableEditAddress1, setEnableEditAddress1] = useState(false);
  const canEdit = !(allowEditAddress1 && enableEditAddress1);
  const originAddress = `${shipment?.dropoff_address?.street}, ${shipment?.dropoff_address?.city}, ${shipment?.dropoff_address?.state} ${shipment?.dropoff_address?.zipcode}`;
  const correctedAddress = `${correctedInfo?.street}, ${correctedInfo?.city}, ${correctedInfo?.state} ${correctedInfo?.zipcode}`;
  const differenceValue = originAddress?.toLowerCase() !== correctedAddress?.toLowerCase();

  useEffect(() => {
    if (clientID) {
      setIsFetching(true);
      getAppFeatures([`CL_${clientID}`, `RG_${regionCode}`, 'AP_DEFAULT']).then((res) => {
        setIsFetching(false);
        if (!res.ok) {
          return;
        }

        setEnableEditAddress1(get(res, 'data.allow_edit_address_1', false));
      });
    }
  }, []);

  const handleChange = (val, setField) => {
    setField(val);
  };

  const handleSave = () => {
    const shipmentId = get(shipment, 'id');

    if (!shipmentId || !allowEditAddress1) return;

    setIsUpdating(true);
    const payload = {
      street,
      street2,
    };

    updateDropoffInfo(shipmentId, payload).then((res) => {
      setIsUpdating(false);

      if (!res.ok) {
        const message = get(res, 'data.message');
        toast.error(message || 'Update failed!');
        return;
      }

      // getShipmentHistory(shipmentId);
      shipmentStore.updateField('id', null);
      setTimeout(() => {
        shipmentStore.updateField('id', shipmentId);
      }, 500);
      shipmentStore.updateDropoffAddress('street', street);
      shipmentStore.updateDropoffAddress('street2', street2);
      toast.success('Update successfully!');
      handleClose();
    });
  };

  return (
    <AxlDialog
      isOpen={isOpen}
      childrenTitle={'Update Dropoff Info'}
      handleClose={() => handleClose()}
      childrenAction={
        isFetching ? null : (
          <Box display="flex" style={{ gap: 8 }}>
            <Button size="small" onClick={() => handleClose()} variant="outlined">
              Cancel
            </Button>
            <Button size="small" onClick={() => handleSave()} variant="contained" color="primary" disabled={isUpdating || canEdit}>
              {isUpdating ? <CircularProgress size={20} style={{ marginRight: 8 }} /> : 'Save'}
            </Button>
          </Box>
        )
      }
    >
      {isFetching ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" style={{ gap: 16 }}>
          {differenceValue && (
            <Box>
              <span>Corrected Address: </span>
              <span style={{ color: colors.green }}>{correctedAddress}</span>
            </Box>
          )}
          {canEdit && (
            <Box color={'red'} fontSize={14} mb={1}>Address line 1 is not available to update right now, please check back later.</Box>
          )}
          <TextFieldCustom placeholder={LABEL.STREET} label={LABEL.STREET} value={street} onChange={(evt) => handleChange(evt.target.value, setStreet)} disabled={canEdit} />
          <TextFieldCustom placeholder={LABEL.STREET_2} label={LABEL.STREET_2} value={street2} onChange={(evt) => handleChange(evt.target.value, setStreet2)} disabled={canEdit} />

          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextFieldCustom placeholder={LABEL.CITY} label={LABEL.CITY} value={_.get(shipment, 'dropoff_address.city', '')} disabled={true} />
            </Grid>
            <Grid item xs={4}>
              <TextFieldCustom placeholder={LABEL.STATE} label={LABEL.STATE} value={_.get(shipment, 'dropoff_address.state', '')} disabled={true} />
            </Grid>
            <Grid item xs={4}>
              <TextFieldCustom placeholder={LABEL.ZIPCODE} label={LABEL.ZIPCODE} value={_.get(shipment, 'dropoff_address.zipcode', '')} disabled={true} />
            </Grid>
          </Grid>
        </Box>
      )}
    </AxlDialog>
  );
}

export default DropoffInfoDialog;
